import * as Y from '../../../../shared/yjs';
import { CommandContext } from './internal/yDocHighLevelAPI';
import { readAllToMarkdown, readNodesToMarkdown, readRangeToMarkdown, searchToMarkdown } from './internal/yDocLLMAPI';

export function toMarkdown(yDoc: Y.Doc): string {
  return readAllToMarkdown(yDoc);
}

export function rangeToMarkdown(ctx: CommandContext, fromId: string, toId: string): string {
  return readRangeToMarkdown(ctx, fromId, toId);
}

export function nodesToMarkdown(ctx: CommandContext, nodeIds: string[]): string {
  return readNodesToMarkdown(ctx, nodeIds);
}

export function searchMarkdown(ctx: CommandContext, query: string, limit = 50): string {
  return searchToMarkdown(ctx, query, limit);
}


